import { render } from "./ColorScreenMod.vue?vue&type=template&id=7fdd9f17&scoped=true"
import script from "./ColorScreenMod.vue?vue&type=script&lang=js"
export * from "./ColorScreenMod.vue?vue&type=script&lang=js"

import "./ColorScreenMod.vue?vue&type=style&index=0&id=7fdd9f17&scoped=true&lang=scss"

import exportComponent from "/Users/cw/Desktop/BME/screen_project_315/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7fdd9f17"]])

export default __exports__